import { jsx } from "react/jsx-runtime";
import assert from "assert";
import { resolveCollapsibleAlignmentProps } from "../../utils/collapsibleAlignmentProps.mjs";
import { Box } from "../Box/Box.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { fitContentMobile, fitContentTablet, fitContentDesktop, fitContentWide } from "./Inline.css.mjs";
const Inline = ({
  space = "none",
  align,
  alignY,
  collapseBelow,
  reverse = false,
  component = "div",
  data,
  children,
  ...restProps
}) => {
  assert(
    !reverse || reverse && collapseBelow,
    "The `reverse` prop should only be applied in combination with the `collapseBelow` prop.\nIf you do not want to collapse responsively, it is recommended to reorder the content directly.\n\nSee documentation for details: https://seek-oss.github.io/braid-design-system/components/Inline#reversing-the-order"
  );
  const {
    collapseMobile,
    collapseTablet,
    collapseDesktop,
    collapsibleAlignmentProps
  } = resolveCollapsibleAlignmentProps({
    align,
    alignY,
    collapseBelow,
    reverse,
    inlineItems: true
  });
  return /* @__PURE__ */ jsx(
    Box,
    {
      component,
      ...collapsibleAlignmentProps,
      gap: space,
      flexWrap: "wrap",
      className: collapseBelow ? {
        [fitContentMobile]: !collapseMobile,
        [fitContentTablet]: !collapseTablet,
        [fitContentDesktop]: !collapseDesktop,
        [fitContentWide]: true
      } : fitContentMobile,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children
    }
  );
};
export {
  Inline
};
